import { DesktopDatePicker } from '@mui/x-date-pickers';
import { Dispatch, SetStateAction, useState } from 'react';
import moment, { Moment } from 'moment';
import 'moment/locale/en-gb';
import { useParams } from 'react-router-dom';

// Set the default locale to "en-gb" for Moment.js
moment.locale('en-gb');

interface WeekNumberDatePickerProps {
  label: string;
  setState: Dispatch<SetStateAction<any>>;
  value: string | undefined;
  disabled?: boolean;
}

export default function WeeklyDatePicker({
  label,
  setState,
  value,
  disabled = false,
}: WeekNumberDatePickerProps) {
  const { id } = useParams();

  const [dateError, setDateError] = useState<string | null>(null);

  const handleDateError = (error: string | null) => {
    if (error === 'minDate' && id) {
      setDateError(null);
    } else {
      setDateError(error);
    }
  };

  return (
    <DesktopDatePicker
      sx={{ width: '100%' }}
      value={value ? moment(value, 'DD-MM-YYYY') : null}
      onChange={(changedValue: Moment | null) => {
        if (changedValue) {
          const formattedDate = moment(changedValue).format('DD-MM-YYYY');
          setState(formattedDate);
        } else {
          setState(undefined);
        }
      }}
      label={label}
      onError={handleDateError}
      displayWeekNumber
      minDate={moment().add(1, 'day').startOf('day')}
      slotProps={{
        textField: {
          error: !!dateError,
        },
      }}
      disabled={disabled}
    />
  );
}
